import { render, staticRenderFns } from "./DropboxBrowser.vue?vue&type=template&id=8c505a2a&"
import script from "./DropboxBrowser.vue?vue&type=script&lang=js&"
export * from "./DropboxBrowser.vue?vue&type=script&lang=js&"
import style0 from "./DropboxBrowser.vue?vue&type=style&index=0&id=8c505a2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports